import { render, staticRenderFns } from "./shebeileixing.vue?vue&type=template&id=19e83f6c&scoped=true&"
import script from "./shebeileixing.vue?vue&type=script&lang=js&"
export * from "./shebeileixing.vue?vue&type=script&lang=js&"
import style0 from "./shebeileixing.vue?vue&type=style&index=0&id=19e83f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e83f6c",
  null
  
)

export default component.exports